import { IUser } from '@todesktop/shared';

export const ACCOUNT_DELETED_LOGIN_PATH = '/login?accountDeleted=true';

export const defaultUser: Partial<IUser> = {
  lastName: undefined,
  firstName: undefined,
  authInfo: {},
  avatar: undefined,
  currentApplication: undefined,
  customerId: undefined,
  schemaVersion: 2,
};
